import { render, staticRenderFns } from "./myVisitDetail.vue?vue&type=template&id=0452e6f4&scoped=true"
import script from "./myVisitDetail.vue?vue&type=script&lang=js"
export * from "./myVisitDetail.vue?vue&type=script&lang=js"
import style0 from "./myVisitDetail.vue?vue&type=style&index=0&id=0452e6f4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0452e6f4",
  null
  
)

export default component.exports